<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Role" subTitle="Forms" />

    <ListRole />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListRole from "@/components/Pages/Master/Role/ListRole.vue";

export default defineComponent({
  name: "ListRolePage",
  components: {
    PageTitle,
    ListRole,
  },
});
</script>
